export default function getDomainFromUrl(url: string): string {
  try {
    const { hostname } = new URL(url)
    return hostname
  } catch {
    return ""
  }
}